import { HelpArticle } from "@/components/HelpArticle/HelpArticle";
import { Screenshot } from "@/components/Screenshot/Screenshot";
import { createFileRoute } from "@tanstack/react-router";
import leggTilTresidigSkjøte from "./legg-til-tresidig-skjote.png";
import menyLeggTilVedlegg from "./meny-legg-til-vedlegg.png";
import vedleggskategori from "./vedleggskategori.png";

const title = "Tresidig skjøte";

export const Route = createFileRoute("/_authenticated-user/hjelp/tresidig-skjote/")({
  head: () => ({
    meta: [{ title: `${title} | Alice & Bob` }],
  }),
  component: Page,
});

function Page() {
  return (
    <HelpArticle title={title}>
      <p>Slik fyller du ut tresidig skjøte.</p>

      <h2>Opprett tresidig skjøte</h2>
      <p>Trykk på «Legg til dokument» og velg «Tresidig skjøte».</p>
      <Screenshot
        src={leggTilTresidigSkjøte}
        width={502}
        alt="Menyen «Legg til dokument» åpen, med «Tresidig skjøte» markert."
      />

      <p>
        Dokumentet henter automatisk opp data fra Vitec tilknyttet oppdraget. Dersom du er usikker på om det er riktig
        så er dette huskeregel:
      </p>
      <ul>
        <li>
          Hjemmelshaver (iht. grunnboken) skal stå under «<strong>fra</strong>».
        </li>
        <li>Selger (utsteder) må være et selskap.</li>
        <li>
          <strong>NB!</strong> Hjemmelshaver i grunnboken skal stå under «erklæring om sivilstand».
        </li>
        <li>
          <strong>Signering</strong> – Kartverkets systemer vil alltid se etter signatur fra den som er oppført i
          grunnboken som hjemmelshaver. Dersom det kun er utsteder som skal signere, må det lastes opp en fullmakt i
          vedleggskategori «Salgsfullmakt», og signaturberettigede for utsteder legges inn som signatar.
        </li>
      </ul>

      <h2>Legg til vedlegg</h2>
      <p>Trykk på de tre prikkene for å legge til vedlegg.</p>
      <Screenshot
        src={menyLeggTilVedlegg}
        width={327}
        alt="Menyen bak de tre prikkene på dokumentet, med «Legg til vedlegg» markert."
      />

      <p>Velg deretter riktig vedleggskategori («Salgsfullmakt»).</p>
      <Screenshot
        src={vedleggskategori}
        width={431}
        alt="Dialogen «Last opp vedlegg» med nedtrekkslisten over vedleggskategorier åpen."
      />
    </HelpArticle>
  );
}
